import { OnInit, Component, ViewChild, ElementRef } from '@angular/core';
import { PharmacyService } from '../../../services/pharmacyservice';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PharmacyStoreSyncSearchRequestModel, PharmacyStoreSyncSearchResponseModel, PharmacyStoreSyncSearchGridDataMapper, PharmacyStoreSyncSearchGridData } from '../../DTO/pharmacy-store-sync-search';
import { formatDate } from "@angular/common";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable, map, startWith } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-pharmacy-store-sync-search',
  templateUrl: './pharmacy-store-sync-search.component.html',
  styleUrls: ['./pharmacy-store-sync-search.component.css']
})
export class PharmacyStoreSyncSearchComponent  implements OnInit {
  maxFileDate:Date=new Date();
  form: FormGroup;
  FileDate: FormControl;
  isLoading: boolean=false;
  dataSource:any;
  displayedColumns: any[] = ['ActionType', 'NCPDPID', 'NPI', 'PharmacyName','OldPharmacyName','ProcessFileDate', 'ProcessFileName', 'ProcessDate'];
  pharmacyStoreSyncGridData=new PharmacyStoreSyncSearchGridData();
  pharmacyStoreSyncData = new PharmacyStoreSyncSearchResponseModel();
  pharmacyStoreSyncSearchRequestModel=new PharmacyStoreSyncSearchRequestModel();
  panelOpenState = false;
  pharmacyStoreSyncGridCopy:any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private pharmacyService: PharmacyService, private toastr:ToastrService,
    private router: Router) {
     
  }

  ngOnInit() {
    this.createFormControls();
    this.createForm();
  }

  createFormControls() {
    this.FileDate = new FormControl(new Date(new Date().toDateString()), Validators.required);
  }

  createForm() {
    this.form = new FormGroup({
      FileDate: this.FileDate
    });
  }

  get errorMessageForFileDate():string{
    const syncform: FormControl = (this.form.get('FileDate') as FormControl);
    return syncform.hasError('matDatepickerParse') ?
    'Invalid date' :
    syncform.hasError('required') ?
    'File date is required' :
    syncform.hasError('max date') ?
    'File date should be less than equal to today date':""
  }

  dateValidation()
  {
     let fileDate=new Date(Date.parse(this.form.get('FileDate')?.value))
     this.FileDate.setErrors({'max date': null});
     this.FileDate.updateValueAndValidity();
     if(fileDate>new Date(new Date().setHours(0,0,0,0))) {
        this.FileDate.setErrors({'max date': true});
        this.form.get('FileDate')?.markAsTouched();
        return;
     }
  }

  onDateSelect(event:any){
    this.dateValidation();
  }

  onDateInputkeyup(event:any)
  {
    this.form.get('FileDate')?.markAsTouched();
    this.dateValidation();
  }

  submitForm() {
    if (this.form.valid) {
      this.isLoading = true;
      this.pharmacyStoreSyncSearchRequestModel=new PharmacyStoreSyncSearchRequestModel();
      this.pharmacyStoreSyncSearchRequestModel.FileDate = formatDate(this.form.get('FileDate')?.value, 'yyyy-MM-dd', 'en-US');
      this.LoadPharmacyStoresSyncGrid(false);
    }
  }

  private LoadPharmacyStoresSyncGrid(clearTable:boolean)
{
  if(clearTable)
  {
    this.pharmacyStoreSyncGridData=new PharmacyStoreSyncSearchGridData();
    if (this.dataSource!=undefined && this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource=null;
  }
  else{
    this.pharmacyService.getPharmacyStoreSyncSearchGrid(this.pharmacyStoreSyncSearchRequestModel)
        .subscribe(res => {
      this.pharmacyStoreSyncGridData = res;
      this.pharmacyStoreSyncGridCopy = JSON.parse(JSON.stringify(this.pharmacyStoreSyncGridData.pharmacyStoreSyncSearchData))
      this.dataSource = new MatTableDataSource(this.pharmacyStoreSyncGridData.pharmacyStoreSyncSearchData);
      
      this.isLoading = false;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
        },(error: any)=>{
          this.isLoading=false;
          this.toastr.error(error);
        });
      }
  }

  clearSearch(){
    this.ngOnInit();
    this.LoadPharmacyStoresSyncGrid(true);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ExportToExcel() {
    if(this.pharmacyStoreSyncGridCopy!=null && this.pharmacyStoreSyncGridCopy.length>0)
    {
    let PharmacyStoreSyncArray: { "Action Type": any; "NCPDP ID": any; "NPI": any; "Current Pharmacy Chain": any; "Previous Pharmacy Chain": any; "ProcessFileDate": any; "ProcessFileName": any; "ProcessDate": any; }[]=[];
      this.pharmacyStoreSyncGridCopy.forEach((pharmacyStoreSyncModel: any)=> {
        PharmacyStoreSyncArray.push(
        {
          "Action Type":pharmacyStoreSyncModel.ActionType,
          "NCPDP ID":"\t" +pharmacyStoreSyncModel.NCPDPID,
          "NPI":"\t" +pharmacyStoreSyncModel.NPI,
          "Current Pharmacy Chain":pharmacyStoreSyncModel.PharmacyName,
          "Previous Pharmacy Chain":pharmacyStoreSyncModel.OldPharmacyName,
          "ProcessFileDate":pharmacyStoreSyncModel.ProcessFileDate,
          "ProcessFileName":pharmacyStoreSyncModel.ProcessFileName,
          "ProcessDate":pharmacyStoreSyncModel.ProcessDate
        })
       });
  
        const pharmacyStoreSync: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSON.parse(JSON.stringify(PharmacyStoreSyncArray)),);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, pharmacyStoreSync, 'Pharmacy Store');
        XLSX.writeFile(wb, 'Pharmacy Store.csv');
    }
    else{
      this.toastr.error("No Data to export");
    }
  }
}
